<template>
  <div class="modal fade" id="create-quicknote-form" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="createQuickNotelLabel">Add quick note</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="note" class="form-label" aria-label="Note" aria-placeholder="Note">Note</label>
            <textarea v-model="note" id="note" rows="4" cols="50" class="form-control"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click.prevent="submitQuickNoteForm">Create</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="delete-contacts-form" tabindex="-1" aria-labelledby="createprojectlLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="createprojectlLabel">Επιβεβαίωση διαγραφής</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Είστε σίγουροι ότι θέλετε να διαγράψετε την επιλεγμένη επαφή;</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Άκυρο</button>
          <button type="button" class="btn btn-danger text-white" @click="handleArchiveContact(selectedRowToDelete?.id)">Διαγραφή</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="show-notes" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="createQuickNotelLabel">Notes</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="table-responsive">
              <table v-if="notes && notes.length" class="table table-hover align-middle mb-0 mis_table">
                <thead>
                  <tr>

                    <th style="width:45%">
                      Note
                    </th>
                    <th>
                      Created By
                    </th>
                    <th>
                      Created Date
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in notes" :key="index">
                    <td>{{ row.note }}</td>
                    <td>{{ row.user.username }}</td>
                    <td>{{ row.created_at }}</td>
                    <td><button v-if="ownNote(row) || superUser" class="btn btn-dark" @click="deleteNoteRow(row.id)"
                        style="color: var(--secondary-color); font-weight: bold;">Delete</button></td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <p>No notes found.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Close</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="column-select-modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold">Select Columns to Display</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Select2
            v-model="selectedColumns"
            :options="columns.map(col => ({ id: col.value, text: col.label }))"
            :settings="select2Settings"
            :multiple="true"
            class="form-control"
          />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <!-- Column Selection Dropdown -->
    <div class="d-flex justify-content-between mb-2">
      <!-- <div class="col">
        <label class="mb-1">Selected Columns:</label>
        <Select2 v-model="selectedColumns" :options="columns.map(col => ({ id: col.value, text: col.label }))"
          :settings="select2Settings" :multiple="true" class="form-control border-0" />
      </div> -->
      <!-- <div class="dropdown align-items-center" @click="toggleDropdown" @blur="closeDropdown" tabindex="0">
        <button class="ms-2 me-2 mt-4 ms-sm-3 btn btn-primary dropdown-menu-toggler" type="button"
          style="color:var(--secondary-color); font-weight:bold">
          <i class="wx-ic wx-ic-trash" title="Archive"></i>
        </button>
        <ul class="dropdown-menu border-0 shadow p-3 border-0" :class="{ 'show': isDropdownOpen }"
          :style="dropdownStyle">
          <li><a class="dropdown-item py-2 rounded archiveSelected" href="#"
              @click.prevent="showConfirmationModal">Αρχειοθέτηση
              επιλεγμένων</a>
          </li>
        </ul>
      </div> -->
    </div>

    <!-- Table -->
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0 mis_table">
        <thead>
          <tr>
            <!-- <th>
              <div>
                <input type="checkbox" id="checkAllToggle" @click="toggleSelectAll" />
              </div>
            </th> -->
            <!-- <th v-for="col in filteredColumns" :key="col">
              <div>
                {{ getLabel(col) }}
                <i class="fa fa-sort sorting-icon" @click.prevent="handleSortBy(col)"></i>
              </div>
            </th> -->
            <th v-for="col in filteredColumns" :key="col">
              <div v-if="col === 'clientSupplier'" class="d-flex align-items-center">
                <span class="th-label-underline d-flex align-items-center gap-2"><span class="dot bg-client"></span><span class="dot bg-supplier"></span>{{ getLabel(col) }}</span>
                <!-- <i class="fa fa-sort sorting-icon ms-2" @click.prevent="handleSortBy(col)"></i> -->
              </div>
              <div v-else>
                <!-- {{ getLabel(col) }} -->
                <span class="th-label-underline">{{ getLabel(col) }}</span>
                <i class="fa fa-sort sorting-icon" @click.prevent="handleSortBy(col)"></i>
              </div>
            </th>
            <!-- <th>
              <div>
                Notes
              </div>
            </th> -->

            <th>
              <!-- <div>
                Actions
              </div> -->
              <button class="btn wx-icon-btn" title="Columns" @click.prevent="openColumnModal">
                <i class="wx-ic wx-ic-columns"></i>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in data" :key="index">
            <!-- <td v-for="col in filteredColumns" :key="col"> -->
              <td
                v-for="col in filteredColumns"
                :key="col"
                :style="col === 'name' ? 'text-align: left;' : ''"
              >
              <template v-if="col === 'clientSupplier'">
                <div class="d-flex flex-column gap-1 nicknamesDiv">
                  <div v-if="row.clientNickname" class="d-flex align-items-center gap-2 text-start">
                    <span class="dot bg-client"></span>
                    <span>{{ row.clientNickname }}</span>
                  </div>
                  <div v-if="row.supplierNickname" class="d-flex align-items-center gap-2 text-start">
                    <span class="dot bg-supplier"></span>
                    <span>{{ row.supplierNickname }}</span>
                  </div>
                </div>
              </template>

              <template v-else-if="isLinkColumn(col)">
                <!-- <router-link :to="{ path: tableOptions.singlePagePath, query: { id: row.id } }" style="color: red;">
                  {{ row[col] }}
                </router-link> -->
                <router-link :to="{ path: tableOptions.singlePagePath, query: { id: row.id } }" v-html="formatName(row[col])"> </router-link>
              </template>

              <template v-else>
                <span @click="handleClick(col, row)">
                  {{ row[col] }}
                </span>
              </template>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <div>
                  <router-link :to="{ path: tableOptions.singlePagePath, query: { id: row.id } }"
                    class="btn btn-link shadow-none" style="font-weight:bold">
                    <i class="wx-ic wx-ic-user wx-contact-type" :class="{ 'is-client': row.clientNickname, 'is-supplier': row.supplierNickname }" title="Go to contact"></i>
                  </router-link>
                </div>
                <div>
                  <button type="button" class="btn btn-link shadow-none" @click="openQuickNoteForm(row)"
                    style="color:var(--secondary-color); font-weight:bold">
                    <i class="wx-ic wx-ic-note" title="Quick note"></i>
                  </button>
                </div>
                <div>
                  <!-- <button class="btn btn-link shadow-none">
                    <img src="../assets/images/contact-list-icon-16.png" alt="" width="30">
                  </button> -->
                  <button  class="btn btn-link shadow-none" @click.prevent="showConfirmationModal(row)">
                    <i class="wx-ic wx-ic-trash" title="Archive"></i>
                  </button>
                </div>
                
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <nav aria-label="Page navigation" v-if="data && data.length">
      <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
        <li class="page-item" v-for="(paginationLink, index) in displayedPaginationLinks" :key="index"
            :class="{ active: paginationLink.active }">
          <router-link
            :to="{ path: tableOptions.path, query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
            v-if="paginationLink.url">
            <span class="page-link" v-html="paginationLink.label"></span>
          </router-link>
          <span class="page-link" v-else v-html="paginationLink.label"></span>
        </li>
      </ul>
      <!-- <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
        <li class="page-item" v-for="(paginationLink, index) in paginationLinks" :key="index"
          :class="{ active: paginationLink.active }">
          <router-link
            :to="{ path: tableOptions.path, query: { ...filters, page: getPageFromUrl(paginationLink.url) } }"
            v-if="paginationLink.url">
            <span class="page-link" v-html="paginationLink.label"></span>
          </router-link>
          <span class="page-link" v-else v-html="paginationLink.label"></span>
        </li>
      </ul> -->
    </nav>
    
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import { create, deleteNote } from "@/services/quicknote";
import Select2 from "vue3-select2-component";
import { useToast } from "vue-toastification";
import { mapGetters } from "vuex";

export default {
  components: {
    Select2,
  },
  computed: {
    ...mapGetters({
      getUserPermission: 'getUserPermission',
      getSuperUserPermission: 'getSuperUserPermission',

    }),
    superUser() {
      return this.getSuperUserPermission === 1;
    },
    displayedPaginationLinks() {
      const links = this.paginationLinks;
      if (!links || links.length <= 8) return links;

      const firstLinks = links.slice(0, 5); // show 4 first
      const lastLinks = links.slice(-2);   // show last 2

      return [...firstLinks, { label: '...', url: null }, ...lastLinks];
    }
  },
  props: {
    columns: Array, // Example: [{ value: "name", label: "Name", isLink: true, linkField: "profileUrl" }]
    data: Array, // Example: [{ name: "John", profileUrl: "/profile/john" }]
    customHandler: Function, // Function to handle clicks
    tableOptions: Object,
    archiveContacts: Function,
    paginationLinks: Array,
    sortBy: Function,
    isLinkColumn: Function,
    refreshTable: Function,
    selectedColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      select2Settings: { multiple: true },
    };
  },
  setup(props, { emit }) {
    // const selectedColumns = ref(props.columns.map(col => col.value));
    const selectedIds = ref([]);
    const isDropdownOpen = ref(false);
    const selectedContact = ref(null);
    const note = ref('');
    const notes = ref([]);
    const selectedColumns = ref([
      "name",
      "clientSupplier",
      "phone",
      "email",
      "afm"
    ]);
    const selectedRowToDelete = ref(null);

    // const formatName = (name) => {
    //   if (!name) return '';
    //   const parts = name.split(' ');
    //   return parts.length > 1
    //     ? `${parts[0]}<br>${parts.slice(1).join(' ')}`
    //     : name;
    // };

    const formatName = (name) => {
      if (!name) return '';
      const parts = name.split(' ');
      if (parts.length === 1) return name;

      const first = parts[0];
      const rest = parts.slice(1).join(' ');

      return `${first}<br><span style='color: #abaaaa;'>${rest}</span>`;
    };

    const getContactIcon = (row) => {
      const hasClient = !!row.clientNickname;
      const hasSupplier = !!row.supplierNickname;

      if (hasClient && hasSupplier) {
        return require('../assets/images/contact-list-icon-20.png');
      } else if (hasClient) {
        return require('../assets/images/contact-list-icon-14.png');
      } else if (hasSupplier) {
        return require('../assets/images/contact-list-icon-21.png');
      } else {
        return require('../assets/images/contact-list-icon-22.png');
      }
    };

    const dropdownStyle = computed(() => ({
      top: isDropdownOpen.value ? '100%' : 'initial',
      right: isDropdownOpen.value ? '0' : 'initial'
    }));

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const closeDropdown = () => {
      isDropdownOpen.value = false;
    };

    watch(selectedColumns, (newVal) => {
      localStorage.setItem("selectedColumns", JSON.stringify(newVal));
    });

    const storedColumns = localStorage.getItem("selectedColumnsContacts");
    if (storedColumns) {
      selectedColumns.value = JSON.parse(storedColumns);
    }

    const filteredColumns = computed(() => selectedColumns.value);

    const getLabel = (value) => {
      const column = props.columns.find(col => col.value === value);
      return column ? column.label : value;
    };

    const isLinkColumn = (value) => {
      return props.isLinkColumn(value);
    };

    const getLinkField = (value) => {
      const column = props.columns.find(col => col.value === value);
      return column?.linkField || value;
    };

    // Handle Click Events
    const handleClick = (column, row) => {
      if (props.customHandler) {
        props.customHandler(column, row);
      } else {
        emit("row-clicked", { column, row });
      }
    };

    const showConfirmationModal = (row) => {
      selectedRowToDelete.value = row;
      $('#delete-contacts-form').modal('show');
    };

    const handleArchiveContact = (id) => {
      props.archiveContacts([id]);
      $('#delete-contacts-form').modal('hide');
    };

    const handleArchiveContacts = () => {
      props.archiveContacts(selectedIds.value);
      $("#delete-contacts-form").modal('hide');
    }

    const getPageFromUrl = (url) => {
      if (!url) return null;
      const urlObj = new URL(url, window.location.origin);
      return urlObj.searchParams.get('page');
    };

    // Handle Sort By
    const handleSortBy = (column) => {
      props.sortBy(column);
    };

    const openQuickNoteForm = (row) => {
      selectedContact.value = row;
      $("#create-quicknote-form").modal('show');
    };

    const submitQuickNoteForm = async () => {
      const response = await create(selectedContact.value.id, { note: note.value });
      if (response.data.success) {
        props.refreshTable();
        useToast().success(response.data.message);
        note.value = '';
        $("#create-quicknote-form").modal('hide');
      } else {
        useToast().error(response.data.message);
      }
    };

    const showNotes = (row) => {
      notes.value = row.notes;
      $("#show-notes").modal('show');
    };

    const openColumnModal = () => {
      $("#column-select-modal").modal("show");
    };

    const toggleSelectAll = () => {
      if (!$("#checkAllToggle").is(":checked")) {
        selectedIds.value = [];
      } else {
        let ids = [];
        if (props.data && props.data.length) {
          props.data.forEach(function (d) {
            ids.push(d.id);
          });
        }
        selectedIds.value = ids;
      }
    };

    const deleteNoteRow = async (id) => {
      const r = await deleteNote(id);
      if (r.data.success) {
        useToast().success(r.data.message);
      } else {
        useToast().error(r.data.message);
      }
    };

    const ownNote = (note) => {
      return note.user.id == localStorage.getItem('current_user_id');
    };

    return { ownNote, deleteNoteRow, showConfirmationModal, notes, note,  showNotes, submitQuickNoteForm, openQuickNoteForm, handleArchiveContacts, toggleSelectAll, dropdownStyle, closeDropdown, toggleDropdown, isDropdownOpen, handleSortBy, selectedIds, selectedColumns, filteredColumns, getLabel, isLinkColumn, getLinkField, handleClick, getPageFromUrl, getContactIcon, handleArchiveContact, selectedRowToDelete, openColumnModal, formatName };
  },
};
</script>

<style scoped>
.table-container {
  margin-top: 0;
}

.column-selection {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #fff;
  padding: 8px;
}

.table tr td {
  border: 0px solid #fff;
  font-weight: 600;
}

th {
  background-color: #f4f4f4;
}

.link {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.clickable {
  cursor: pointer;
  color: #007bff;
}

.clickable:hover {
  text-decoration: underline;
}

.select2-container--default .select2-selection--multiple {
  border: 0px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.bg-client {
  background-color: #64abff;
  /* Bootstrap Primary Blue */
}

.bg-supplier {
  background-color: #ff9e29;
  /* Bootstrap Orange */
}

.mis_table tr th:not(.no-after)::after {
  content: '';
  position: absolute;
  top: 10%;
  right: 0;
  height: 70%;
  width: 0px;
  border-radius: 99px;
  background-color: var(--secondary-color);
}

.mis_table tr th div {
  font-size: 20px;
  font-weight: 500;
}

.th-label-underline {
  border-bottom: 2px solid #dedede;
  display: inline-flex;
  /* keeps the border just under content */
  padding-bottom: 2px;
}

.nicknamesDiv {
  width: 80%;
  margin: 0 auto;
}
::v-deep(.select2-container--default .select2-selection--multiple) {
  background-color: #808080;
  border: 0px;
  color: white;
  padding: 3px 10px;
}

::v-deep(.select2-container--default .select2-selection--multiple .select2-selection__choice) {
  background-color: #808080;
  color: white;
  border: 0px;
  padding: 3px 10px;
}
::v-deep(.select2-container--default .select2-selection--multiple .select2-selection__choice__remove){
  margin-right: 8px;
  color: white;
}
</style>
